import React from "react";
import Header from "../Header";
import Footer from "../Footer";

import { Link } from "react-router-dom";
import AudioPlayer from "../Audio/AudioPlayer";

const BlogDetails21 = (props) => {
  const img1 = "/assets/wp-content/uploads/2018/12/ramdev-gallery23.jpg";
    return (
        <>
         <meta name="keywords" content="બાબા રામદેવ , રામદેવજી,  રામદેવ પીર, રામશા પીર, Baba Ramdev, Ramdevji, Ramdev Pir, Ramshapir" />
      
            {/* <div className="body_wrap">
        <div className="page_wrap"> */}


            <Header />
            <div
                data-elementor-type="cpt_layouts"
                data-elementor-id="46"
                className="elementor elementor-46"
            >
                <section
                    className="elementor-section elementor-top-section elementor-element elementor-element-52ebb12  elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                    data-id="52ebb12"
                    data-element_type="section"
                    data-settings='{"background_background":"classic"}'
                    style={{ height: "30rem", marginBottom: "5rem" }}
                >
                    <div className="elementor-background-overlay"></div>
                    <div className="elementor-container elementor-column-gap-extended">
                        <div
                            className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-ae9d67e sc_inner_width_none sc_layouts_column_icons_position_left"
                            data-id="ae9d67e"
                            data-element_type="column"
                        >
                            <div className="elementor-widget-wrap elementor-element-populated">
                                <section
                                    className="elementor-section elementor-inner-section elementor-element elementor-element-fcf91b3 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                                    data-id="fcf91b3"
                                    data-element_type="section"
                                >
                                    <div className="elementor-container elementor-column-gap-extended">
                                        <div
                                            className="elementor-column elementor-col-100 elementor-inner-column elementor-element elementor-element-93dfaf4 sc_inner_width_none sc_layouts_column_icons_position_left"
                                            data-id="93dfaf4"
                                            data-element_type="column"
                                        >
                                            <div className="elementor-widget-wrap elementor-element-populated">
                                                <div
                                                    className="sc_layouts_item elementor-element elementor-element-847c2c5 sc_fly_static elementor-widget elementor-widget-spacer"
                                                    data-id="847c2c5"
                                                    data-element_type="widget"
                                                    data-widget_type="spacer.default"
                                                    style={{ height: "8rem" }}
                                                >
                                                    <div className="elementor-widget-container">
                                                        <div className="elementor-spacer">
                                                            <div className="elementor-spacer-inner"></div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div
                                                    className="sc_layouts_item elementor-element elementor-element-8fe49e3 sc_fly_static elementor-widget elementor-widget-trx_sc_layouts_title"
                                                    data-id="8fe49e3"
                                                    data-element_type="widget"
                                                    data-widget_type="trx_sc_layouts_title.default"
                                                >
                                                    <div className="elementor-widget-container">
                                                        <div
                                                            id="trx_sc_layouts_title_515615674"
                                                            className="sc_layouts_title sc_align_center with_content without_image without_tint"
                                                        >
                                                            <div className="sc_layouts_title_content">
                                                                <div className="sc_layouts_title_title">
                                                                    {" "}
                                                                   
                                                                </div>
                                                                <div className="sc_layouts_title_breadcrumbs">
                                                                    <div className="breadcrumbs">
                                                                        
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>{" "}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            {/* <div className="menu_mobile_overlay"></div>
      <div className="menu_mobile menu_mobile_fullscreen scheme_inherit">
        <div className="menu_mobile_inner">
          <a className="menu_mobile_close icon-cancel"></a>
          <Link to={'/'} className="sc_layouts_logo">

            <img
              src={logoimg}
              alt="Vihara"
              width="134"
              height="78"
            />{" "}
          </Link>
          <nav
            className="menu_mobile_nav_area"
            itemScope
            itemType="//schema.org/SiteNavigationElement"
          >
            <ul id="menu_mobile_1510458944">
              <li
                id="menu_mobile-item-203"
                className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-203"
              >
                <a href="/">
                  <span>Home</span>
                </a>

              </li>
              <li
                id="menu_mobile-item-204"
                className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-204"
              >
                <a href="#">
                  <span>Gallery</span>
                </a>
                <ul className="sub-menu">
                  <li
                    id="menu_mobile-item-209"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-209"
                  >
                    <a href="/Audio">
                      <span>Audio</span>
                    </a>
                  </li>
                  <li
                    id="menu_mobile-item-208"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-208"
                  >
                    <a href="/Video">
                      <span>Video</span>
                    </a>
                  </li>
                  <li
                    id="menu_mobile-item-206"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-206"
                  >
                    <a href="/Gallery2">
                      <span>Images</span>
                    </a>
                  </li>

                </ul>
              </li>
              <li
                id="menu_mobile-item-224"
                className="menu-item menu-item-type-custom menu-item-object-custom current-menu-ancestor current-menu-parent menu-item-has-children menu-item-224"
              >
                <a href="#">
                  <span>About</span>
                </a>
                <ul className="sub-menu">
                  <li
                    id="menu_mobile-item-447"
                    className="menu-item menu-item-type-post_type menu-item-object-page current-menu-item page_item page-item-407 current_page_item menu-item-447"
                  >
                    <a
                      href="/About"
                      aria-current="page"
                    >
                      <span>Ashram</span>
                    </a>
                  </li>

                  <li
                    id="menu_mobile-item-449"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-449"
                  >
                    <a href="/plan-visit">
                      <span>Plan a Visit</span>
                    </a>
                  </li>
                </ul>
              </li>

              <li
                id="menu_mobile-item-316"
                className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-316"
              >
                <a href="/BlogMain">
                  <span>Stories</span>
                </a>
              </li>
              <li
                id="menu_mobile-item-312"
                className="menu-item menu-item-type-post_type menu-item-object-page menu-item-312"
              >
                <a href="/Books">
                  <span>Books</span>
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
 */}



            <div className="page_content_wrap blog-details">
                <div className="content_wrap" >
                    <div className="content">
                        <div id="container" className="give-wrap container">
                            <div id="content" role="main">
                                <div
                                    id="give-form-288-content"
                                    className="post-288 give_forms type-give_forms status-publish has-post-thumbnail"
                                >
                                    <div
                                        id="give-sidebar-left"
                                        className="give-sidebar give-single-form-sidebar-left"
                                    >
                                        <div className="images">
                                            <img
                                                width="1024"
                                                height="576"
                                                src={img1}
                                                className="attachment-large size-large wp-post-image blog-img"
                                                alt=""
                                                decoding="async"
                                                sizes="(max-width: 1024px) 100vw, 1024px"
                                            />
                                        </div>
                                    </div>
                                    <div className="summary entry-summary">
                                        <h2 itemProp="name" className="give-form-title entry-title">
                                            મેવાડના દલુ વાણિયાને પરચો
                                        </h2>{" "}
                                        <div
                                            id="give-form-288-wrap"
                                            className="give-form-wrap give-display-onpage"
                                        >
                                            <div className="give-goal-progress">
                                                <div
                                                    className="raised blog-title"
                                                   
                                                >
                                                    <span className="income">મેવાડના દલુ વાણિયાને પરચો



                                                    </span>
                                                </div>
                                            </div>

                                            <div
                                                id="give-form-content-288"
                                                className="give-form-content-wrap give_pre_form-content"
                                            >
                                                <p className="paragraph-content">
                                                    માળવ કેરો સંઘવી, ગામ રણુંજા જાય, ભીડર કેરો વાણિયો, દલુ પૂછતો ત્યાંય. કયા ગામનો સંઘ ને કઈ જાત્રાએ જાય, કૃપા કરીને સંઘવી, કહો એનો મહિમાય ?
                                                    શેઠ ! અમે માળવાથી આવીએ છીએ. રણુંજામાં પરગટ પરચા પૂ શ્રી રામદેવપીરની જાત્રાએ જઈએ છીએ. ભાદરવા માસની દેશમ- અગિયારશને ત્યાં મોટો મેળો ભરાય છે. દર વરસે અમારો સંઘ રામાપીરનાં દર્શને જાય છે, પરગટ રામા પીરજી, ગામ રણુંજા માંય,
                                                    માગ્યા પરચા પૂરતા, સમર્યે કરતા સહાય. જૈન દલુ શેઠે પૂછ્યું : ‘ભાઈ ! એવા તો કેવા પરચા પૂરે છે ?’
                                                    રામાપીરના પરચા એ તો જાગતું પીરાણું છે, શેઠ ! એમના દર્શન માત્રથ આંધળા દેખતા થાય છે. રક્તપીતિયાંના કોઢ મટે છે, અને વાંઝિયાને ઘેર પાર બંધાય છે. એવા હાજર હજુર દેવ શ્રી રામદેપીર છે. જૈન છતાં શ્રદ્ધાળુ દલુ શેઢે સંઘવીની વાત શેઠાણીને કરી બાધા રાખી કે, જા શ્રી રામાપીર આપણને પુત્ર આપે તો આપણે પુત્રને રામદેવજીના દર્શને લઈ જવો અને ત્યાં તેના બાળ-મવાળ મોટા ઉત્સવથી ઉતરાવવા. શેઠાણીએ પણ બાધા રાખી કે, દ૨૨ોજ ઘીની જ્યોત કરી રામદેવજીનું સ્મરણ કરી ભોજન લેવું.
                                                    બાર મહિના પછી બાધાના પ્રતાપે શેઠાણીને દેવના ચક્ક૨ જેવો પુત્ર જન્મ્યો, શેઠાણીને ઘણો આનંદ થયો.
                                                    જૈન દલુ શેઠ ઊંટના સોદાગાર અને મેવાડના પ્રતિષ્ઠિત વેપારી ગણાતા, પૈસે ટકે પણ સુખી હતા. અઢી વર્ષનો પુત્ર થતાં શેઠાણીએ કહ્યું : ‘હવે રણુંજામાં જ રામદેવજીને પગે લગાડી દીકરાની બાધા પૂરી કરી આવીએ.'
                                                    શેઠે કહ્યું : ‘ભાદરવા માસના મેળામાં જઈ બાધા પૂરી કરી આવીશું. ભાદરવા માસમાં જાત્રાએ નીકળેલો એક સંઘ ભીંડર ગામની ધર્મશાળામાં |

                                                </p>
                                                <p className="paragraph-content">
                                                    ઉતર્યો હતો. લુ શેઠને ખબર મળતાં તેમણે સંપત્તીને મળી સંઘ સાથે રણુંજા જવાનું નક્કી કરી સાથે જવાની તૈયારી કરવા માંડી. સંઘના માણસો રાત્રે જમી પરવારી ધૂન મચાવવા લાગ્યા.
                                                    ભજન --
                                                    પચ્છમ ધરાથી પ્રભુ પધાર્યા પરગટપીર પરાળા, સમરીએ રામ રણુંજાવાળા રે જી. રામ રણુંજાવાળા સમરીએ (૨) દેવ દવારકાવાળા. સમ૰ માતા મિણલદે, પિતા અજમલજી, વડા વીરમદેવભાઈ ? જી, લાસા, લક્ષ્મી, સગુણાબેનડી (૨) સદ્ગુરુ જોગીબાળા. સમ૰ માનવ ભક્ષણ કરે, ભૈરવો કાળ કરાળા રે જી પ્રચંડ રૂપ ધરીને પકડાયો (૨) પૂરી દીધો રે પાતાળ. અનેક એવા પરચા પૂર્યા, ધૂન ઘણી રે ધજાળા રે જી, ‘કેશવ’ પ્રગટ્યા પીર રામદેવ (૨) તુંવરાકુળ ઉજાળા. સમ વખત થતાં ‘શ્રી રામદેવજીની જય' બોલતો સંઘ વિદાય થયો, ત્યાં દલુ શેઠ તૈયાર થઈને આવ્યો.
                                                    સમ
                                                    સંઘ ચાલ્યો ગયો હતો. સંઘની પૂંઠે શેઠશેઠાણી પુત્રને લઈને સાંઢિયા પર બેસી વિદાય થયાં. માર્ગમાં એક ભીલડી મળી. તેણે દલુ શેઠને પૂછ્યું કે, ‘શેઠ ક્યાં જાવ છો ?'
                                                    ‘અમે રણુંજા જાત્રાએ જઈએ છીએ.’ શેઠે કહ્યું.
                                                    ભીલડીએ દોડતા જઈ ભીલને ખબર આપી કે, દલુ શેઠ ખૂબ માલ લઈને જાય છે. આજે અવસર ચૂકવા જેવો નથી. ભીલ તરત જ આડે માર્ગે ઊપડ્યો ને શેઠ આગળ આવી શેઠને પડકાર્યાઃ જે હોય તે આપી દે.'
                                                    ભીલને જોતાં જ શેઠના હાંજા ગગડી ગયા, થર થર ધ્રૂજવા લાગ્યા. ત્યાં ભીલે ગર્જના કરી કહ્યું : ‘શેઠ ! નીચે ઊતરો, જે કાંઈ હોય તે સીધી રીતે આપી દો.' શેઠે ધ્રૂજતાં ધ્રૂજતાં સાંઢ જોકારી, ત્રણે જણાં નીચે ઊતર્યાં. છોકરા તો ભયનો માર્યો ચીસો પાડવા લાગ્યો. શેઠાણી કરગરવા લાગી. ઇલુ શેઠ માલ સોંપવાની આનાકાની કરતાં જ હત્યારા લૂંટારાએ ગુસ્સે થઈને તલવારથી ઇલુ શેઠનું માથું ધડથી જુદું કરી નાખ્યું. શેઠાણી મૂર્છા ખાઈ જમીન ઉપર ઢળી પડી. થોડી વારે મૂર્છા વળતાં જોયું તો

                                                </p>
                                                <p className="paragraph-content">
                                                    લૂંટારો શેઠને મારી નાખી તમામ ધન, દાગીના લૂંટી ગયો હતો. કલ્પાંત કરતી શેઠાણી શ્રી રામદેવજીને પુકાર કરવા લાગી કે, પીરજી ! હૈ નોંધારાના આધાર ! પીર રામદેવજી મારી વ્હાર કરો,
                                                    શેઠાણીનો પુકાર શ્રી રામદેવજીએ સાંભળ્યો. તુરત જ લીલુડા ઘોડે સવારે જ ચોર પાછળ પડ્યા અને ચોરને પડકારતાં કહ્યું : ‘ઊભો રહે, ચોરટા ! ' વાણિયાને મારી માલ લૂંટી જાય છે તે માલ તને કેમ પચશે ?’
                                                    લુંટારો બેધડક બોલ્યો : ‘હું ચોર નથી. આ તો મારો માલ છે,’
                                                    ‘જૂઠ્ઠું બોલ્યો ચોરટા ? એનું ફળ તને ચખાડું.’ શ્રી રામદેવજીના શબ્દ નીકળતાં ભીલ આંધળો ભીંત બની ગયો. તેના આખા શરીરે કોઢ નીકળી આવ્યા અને બીલ
                                                    ત્યાં જ પટકાઈ પડ્યો !
                                                    રામદેવજીએ બધો માલ લાવી શેઠાણીને આપતાં કહ્યું : “આ શેઠનું માથું સાથે જોડી દો !' ધડ સાથે માથું જોડતાં ઉતાવળમાં સાંધામાં ચોટલી વચ્ચે દબા ગઈ અને ચોટલીનો છેડો બહાર દેખાય તેમ રહી ગયો અને શેઠ થોડી વારમાં આળસ મરડીને બેઠા થયા. તેમણે બોચીમાં હાથ ફેરવ્યો તો ચોટલી વચ્ચે દબાયેલી અને છેડો બહાર નીકળેલો જોયો. આ જોઈ શેઠને આશ્ચર્ય થયું.
                                                    રામદેવજીએ બનેલી વાત જણાવી કહ્યું : ‘તમારા વંશની આ નિશાની રહેશે. જેને ચોટલી ગળાના પાછલા ભાગમાં હશે તે તમારા વંશના ગણાશે.'
                                                    શેઠશેઠાણી અને બાળક રામદેવજીને પગે પડ્યા. તુરત પ્રકાશ થયો ને શી ગયો અને રામદેવજી અદૃશ્ય થયા. રાત્રિ પડી હોવાથી ત્રણે જણાં નિદ્રાધિન થયાં. સવારે જાગીને જુએ છે, તો તેઓ રણુંજાના પાદરમાં પહોંચેલા હતા.
                                                    જૈન દલુ
                                                    લાવી, રામદેવજીના પગમાં પડી, ચરણધૂલિ માથે ચઢાવી શેઠે ભગવો ભેખ પહેરી શેઠે આનંદપૂર્વક પુત્રની બાધા પૂરી કરી. રણુંજામાં ભગવાં કપ લીધો. શ્રી રામદેવજીના ભાવિક ભક્તો આશ્ચર્ય પામ્યા અને પૂછવા લાગ્યા કે, શે ભગવા પહેરવાનું કારણ શું ? બધાંને દલુ શેઠે રામદેવજીના પરચાની વાત માંડીને કહી અને ભક્તિ ભાવપૂર્વક ગાવા લાગ્યા :
                                                    છો
                                                    -------
                                                    માતા મિણલદેના જાયા; અજમલજીના બેટા, વીરમદેના વીરા, રાણી નેતલના ભરથાર, મારો હેલો સાંભળો હો... જી.
                                                    મેવાડના દલુ વાણિયાને પરચો
                                                    મારો હેલો સાંભળો રણુંજાના રાય,
                                                </p>
                                                <p className="paragraph-content">
                                                    મારો હેલો સાંભળો રણુંજાના રાય, હુકમ કરો તો પીર જાત્રાઉં થાય. મારો૰ વાણિયો ને વાણિયણ જાત્રાએ જાય; ધાય...મારો માલ દેખીને ચોર વાંસે વાંસે ગાઢી ગાઢી ઝાડિયું ને વસમી છે વાટ, જે હતા વાણિયા ને ત્રીજો થયો સાથ...મારો ઊંચા ઊંચા ડુંગરા ને વચમાં છે ઝોળ, મારી નાખ્યો વાણિયાને માલ લઈ ગયા ચોર...મારો ઊભી ઊભી અબળા કરે રે પોકાર,
                                                    સોગટે રમતા પીરને કાને ગયો અવાજ ...મારો૦ விம் ઘોડલો ને હાથમાં છે તીર; વારે ચડવા રામદે’પીર ...મારો
                                                    વાણિયાની
                                                    기
                                                    ઊઠ ઊઠ વાણિયણ ઘડ માથું જોડ; ભુવનમાંથી ગોતી લાવું ચોર ...મારો ચોરટાઓ કેટલેક જાવ,
                                                    જાવ જાવ
                                                    વાણિયાનો માલ તમે કેટલા દહાડા ખાવા ...મારો આંખે કરું આંધળો ડીલે કાઢું કોઢ; દુનિયા જાણે આ તો રામાપીરનો ચોર ...મારો ગાય ‘દલુ વાણિયો' ને ભલી રાખી ટેક; રણુંજા શહેરમાં વાણિયે પહેરી લીધો ભેખ ...મારો દલુ શેઠે ભેખ લઈને શ્રી રામદેવજીના ભજનભાવમાં જીવન વિતાવ્યું.

                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>{" "}
                </div>
            </div>
            {/* </div>
      </div> */}
            <div>
                <Footer />
                {/* <AudioPlayer state={props.state} onPlay={(isPlay) => this.setState({ isPlay })} /> */}
            </div>
        </>
    );
};

export default BlogDetails21;
